import { ApiHelper } from '../ApiHelper';

type NavState = {
    env: number;
    metricType: number;
    process: number;
    startDate: Date | null;
    endDate: Date | null;
};

type QueryParams = {
    env: number;
    metricType: number;
    process: number;
    startDate: string;
    endDate: string;
};

export async function ComponentLoader({ request, params }: { request: Request; params: { serviceName: string } }): Promise<{ components: any; navState: NavState }> {
    const serviceName = params.serviceName;
    const url = new URL(request.url);
    const qs = url.searchParams;
    const navState: NavState = {
        env: qs.get('env') == null ? 1 : Number(qs.get('env')),
        metricType: qs.get('metricType') == null ? 0 : Number(qs.get('metricType')),
        process: qs.get('process') == null ? 0 : Number(qs.get('process')),
        startDate: qs.get('startDate') == null ? null : new Date(qs.get('startDate')!),
        endDate: qs.get('endDate') == null ? null : new Date(qs.get('endDate')!),
    };

    try {
        const components = await getComponents(
            serviceName,
            {
                env: navState.env,
                metricType: navState.metricType,
                process: navState.process,
                startDate: navState.startDate ? navState.startDate.toISOString() : '',
                endDate: navState.endDate ? navState.endDate.toISOString() : '',
            }
        );
        return { components, navState };
    } catch (error) {
        return { components: [], navState };
    }
}

async function getComponents(serviceName: string, queryParams: QueryParams): Promise<any> {
    const apiUrl = `/api/service/${serviceName}/components?` + componentsQueryToQueryString(queryParams);
    const components = await ApiHelper(apiUrl);
    return components;
}

function componentsQueryToQueryString(qp: QueryParams): string {
    const qs = new URLSearchParams();
    qs.set('env', qp.env.toString());
    qs.set('metricType', qp.metricType.toString());
    qs.set('process', qp.process.toString());
    if (qp.startDate) {
        qs.set('startDate', qp.startDate.toString());
    }
    if (qp.endDate) {
        qs.set('endDate', qp.endDate.toString());
    }
    return qs.toString();
}